// Savings breakdown modal — savings is DERIVED, not a transaction type.
// Formula: max(0, income + revenue - expense - recurring) for the current month.
import { useEffect, useState } from "react";
import { X, PiggyBank } from "lucide-react";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { useAuth } from "@/context/AuthContext";

const fmt = (n) => Math.round(Number(n || 0)).toLocaleString();

export function CounterDetailsSavings({ onClose }) {
  const { lang } = useI18n();
  const { user } = useAuth();
  const [s, setS] = useState(null);
  const ccy = user?.currency || "AED";
  const AR = lang === "ar";
  useEffect(() => {
    api.get("/dashboard/summary").then((r) => setS(r.data)).catch(() => setS({ error: true }));
  }, []);

  const tm = s?.this_month || {};
  const income = tm.income || 0, revenue = tm.revenue || 0;
  const expense = tm.expense || 0, recurring = tm.recurring || 0;
  const savings = Math.max(0, income + revenue - expense - recurring);
  const rows = [
    { label: AR ? "الدخل الشهري" : "Income", v: income, sign: "+", cls: "text-emerald-700" },
    { label: AR ? "الإيرادات" : "Revenue", v: revenue, sign: "+", cls: "text-emerald-700" },
    { label: AR ? "المصاريف" : "Expenses", v: expense, sign: "−", cls: "text-red-700" },
    { label: AR ? "الأقساط والالتزامات" : "Installments & recurring", v: recurring, sign: "−", cls: "text-red-700" },
  ];

  return (
    <div data-testid="counter-details-modal" dir={AR ? "rtl" : "ltr"} className="fixed inset-0 z-[70] bg-black/40 backdrop-blur-sm grid place-items-end sm:place-items-center p-3" onClick={onClose}>
      <div className="w-full sm:max-w-md neu p-5 max-h-[85vh] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-display text-lg font-extrabold neu-accent-blue flex items-center gap-2"><PiggyBank className="w-5 h-5" />{AR ? "من أين ادّخرت؟" : "Savings breakdown"}</h3>
          <button onClick={onClose} className="w-9 h-9 rounded-full neu-sm grid place-items-center"><X className="w-4 h-4" /></button>
        </div>
        <p className="text-[11px] text-slate-500 mb-3">{AR ? "الادّخار = (دخل + إيراد) − (مصروف + التزامات) — لهذا الشهر" : "Savings = (Income + Revenue) − (Expense + Recurring) — this month"}</p>
        <div className="space-y-2">
          {rows.map((r, i) => (
            <div key={i} className="flex items-center justify-between p-3 rounded-xl neu-sm text-sm">
              <span>{r.label}</span>
              <span className={`tabular-nums font-bold ${r.cls}`}>{r.sign}{fmt(r.v)}</span>
            </div>
          ))}
        </div>
        <div className="p-4 mt-3 rounded-2xl neu-inset flex items-center justify-between">
          <span className="text-sm font-bold">{AR ? "= الادّخار" : "= Savings"}</span>
          <span className="font-display text-xl font-extrabold tabular-nums neu-accent-blue">{fmt(savings)} {ccy}</span>
        </div>
      </div>
    </div>
  );
}
